import stringUtils from "./string-utils";

export function sortEnumValues(values) {
    return [...values].sort(compareEnumEntries);
}

export function sortValuesByField(values, field) {
    return [...values].sort((a, b) =>
        String(a[field]).toLowerCase() > String(b[field]).toLowerCase()
            ? 1
            : String(a[field]).toLowerCase() < String(b[field]).toLowerCase()
              ? -1
              : 0
    );
}

export function sortNumValuesByField(values, field) {
    return [...values].sort((a, b) =>
        Number(a[field]) > Number(b[field]) ? 1 : Number(a[field]) < Number(b[field]) ? -1 : 0
    );
}

export function sortDateValuesByFieldDesc(values, field) {
    return values.sort((a, b) => {
        return new Date(b[field]) - new Date(a[field]);
    });
}

export function sortDateValuesByFieldAsc(values, field) {
    return values.sort((a, b) => {
        return new Date(a[field]) - new Date(b[field]);
    });
}

export function sortStrings(values) {
    return [...values].sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
}

function compareEnumEntries(a, b) {
    if (a.enumIdentifier === "ANY") {
        return -1;
    } else if (b.enumIdentifier === "ANY") {
        return 1;
    }

    if (a.enumDescription) {
        a = a.enumDescription.toLowerCase();
    }
    if (b.enumDescription) {
        b = b.enumDescription.toLowerCase();
    }

    if (stringUtils.isNumericString(a)) {
        a = Number(a);
    }
    if (stringUtils.isNumericString(b)) {
        b = Number(b);
    }

    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
}

export const arraymove = (arr, fromIndex, toIndex) => {
    const element = { ...arr[fromIndex] };
    const toElement = { ...arr[toIndex] };
    const elementSequenceNumber = element.sequenceNumber;
    element.sequenceNumber = toElement.sequenceNumber;
    toElement.sequenceNumber = elementSequenceNumber;
    arr[fromIndex] = toElement;
    arr[toIndex] = element;
};
